import Web3 from "web3";
import { ethers } from "ethers";
import { getCurrentNetwork, NETWORKS } from "src/configs/connection-config";

let web3Reader, etherProviderHttp, etherProviderWS;

function getWeb3Reader() {
  return web3Reader;
}

async function initWeb3Reader() {
  const currentNetwork = getCurrentNetwork() || NETWORKS.BSC_MAINNET;
  const promises = currentNetwork.rpcUrls.map(async (rpc) => {
    const web3 = new Web3(rpc);
    await web3.eth.getBlockNumber();
    return rpc;
  });
  const bestRPC = await Promise.any(promises);
  web3Reader = new Web3(bestRPC);
  try {
    etherProviderHttp = new ethers.providers.JsonRpcProvider(bestRPC);
    etherProviderWS = new ethers.getDefaultProvider(bestRPC);
  } catch (error) {
    console.error(error);
  }
}

let web3Sender;

function getWeb3Sender() {
  return web3Sender;
}

function setWeb3Sender(provider) {
  if (!provider) web3Sender = null;
  else web3Sender = new Web3(provider);
}

export { web3Reader, etherProviderHttp, etherProviderWS, initWeb3Reader, getWeb3Reader, getWeb3Sender, setWeb3Sender };
